// This is generated.  Alter it in blockGroups/formElements/types/JsonViewer.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { id, title, propertyName, required } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    const { isOptional, schemaOptions } = moduleRegistration.resolveFieldFlags(
      required,
      context,
    );
    const maybeOptional = (schema) =>
      isOptional ? Type.Optional(schema) : schema;

    // Build the object schema (unknown shape)
    const objectOptions = {
      title: title,
      'x-id': id,
      'x-dataType': 'object',
      'x-propertyName': propertyName,
      ...schemaOptions,
    };

    const jsonViewerSchema = maybeOptional(Type.Unknown(objectOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: jsonViewerSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'JsonViewer',
  module.exports,
);
